import { Badge } from '@cjdev-internal/visual-stack-x/Badge';

export function renderBadgeByStatus(mode: string) {
  switch (mode) {
    case 'LIVE':
      return (
        <Badge className="badge-override" variant="1">
          LIVE
        </Badge>
      );
    case 'TEST':
      return (
        <Badge className="badge-override" variant="2">
          TEST
        </Badge>
      );
    case 'OFF':
      return (
        <Badge className="badge-override" variant="9">
          OFF
        </Badge>
      );
  }
}
